import api from "./api";

export const soldBikeService = {

  // 📊 Get sold bikes (with filters)
  getSoldBikes: async (params = {}) => {
    try {
      const query = new URLSearchParams(params).toString();
      const response = await api.get(`/sold-bike?${query}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }, 
  
 
  getFilteredSoldBikes: async (params = {}) => {
    try {
      const query = new URLSearchParams(params).toString();
      const response = await api.get(`/filter-sold-bikes?${query}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
    getSpecificBike: async (id) => {
      try {
        const response = await api.get(`/specific-sold-bike-details/${id}`);
        return response.data;
      } catch (error) {
        throw error;
      }
    },


      addPayment: async (soldBikeId, data) => {
    try {
      const response = await api.post(`/add-payment/${soldBikeId}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};


